import {useMutation, useQuery} from '@tanstack/react-query';
import axiosClient from '../services/axiosClient';

export const useGetCodingQuestionQuery = (params) => {
  return useQuery(['problem', params], async () => {
    const {data} = await axiosClient.get('/problem', {
      params,
    });
    return data;
  });
};

export const useGetCodingQuestionDetailsQuery = (problemId) => {
  return useQuery(
    [problemId],
    async () => {
      const {data} = await axiosClient.get(`/problem/${problemId}`);
      return data;
    },
    {
      enabled: !!problemId,
      keepPreviousData: false,
      cacheTime: 0,
    },
  );
};

export const useAddCodingProblem = () =>
  useMutation(async (payload) => {
    // console.log('api payload', payload)
    const {data} = await axiosClient.post('/problem', payload);
    return data;
  });

export const useUpdateProblemMutation = () =>
  useMutation(async ({problemId, ...payload}) => {
    const {data} = await axiosClient.patch(`/problem/${problemId}`, payload);
    return data;
  });

export const useDeleteProblemMutation = () =>
  useMutation(async (problemId) => {
    const {data} = await axiosClient.delete(`/problem/${problemId}`);
    return data;
  });
